/**
 * Guía: Mis Compañías.
 *
 * Contenido derivado del capítulo **35** del manual: §0 (la portada del rol
 * externo, y que lo que se ve aquí es por definición lo que corresponde).
 *
 * La guía sirve a tres roles distintos —el asesor externo y dos internos que
 * trabajan por cartera— y por eso el primer paso explica el criterio de la
 * lista antes que nada.
 */

import type { TourFlow } from '../types';

const MIS_COMPANIAS_PATH = '/my-companies';

export const c35MisCompanias: TourFlow = {
  id: 'admin.my-companies',
  chapter: '35',
  title: 'Mis compañías',
  summary:
    'Tu cartera: qué comercios entran en ella, por qué puede estar vacía y hasta dónde llega.',
  href: MIS_COMPANIAS_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Los comercios que tienes asignados',
      body:
        'No todos los del país: los que te corresponden. Lo que aparece aquí es, por ' +
        'definición, lo que tienes que ver — y es la puerta desde la que se llega al resto.',
      route: MIS_COMPANIAS_PATH,
    },
    {
      id: 'empty-is-not-broken',
      title: 'Una lista vacía no es un fallo',
      body:
        'Significa que no tienes compañías asignadas todavía. Traer un comercio no lo ' +
        'asigna: la asignación es un acto aparte, y hasta que ocurre no aparece aquí.',
      target: 'admin.myCompanies.filters',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'read-mostly',
      title: 'Ver no es administrar',
      body:
        'Desde aquí se consulta la ficha de cada compañía. Aprobar, suspender o cambiar su ' +
        'comisión son decisiones del administrador general, en otra pantalla.',
    },
  ],
};
